import apiService from './api-service';

const ADMIN_ROLE = 1;
const TAX_REPORTS_READ_ROLE = 2;
const REPORTS_READ_ROLE = 3;
const CHARTS_READ_ROLE = 4;
const FUEL_TANKS_READ_ROLE = 5;
const FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE = 6;
const FUEL_TANKS_INFO_READ_ROLE = 8;
const REPORTS_ACCOUNTING_SYSTEM_READ_ROLE = 9;
const CHARTS_ACCOUNTING_SYSTEM_READ_ROLE = 10;
const SUPER_ADMIN_ROLE = 11;
const FUEL_TANKS_MAP_READ_ROLE = 12;
const REPORTS_EXPORT_ROLE = 13;
const FUEL_TANKS_INFO_EXPORT_ROLE = 14;
const REPORTS_GROUP_DAYS_ROLE = 15;
const CHARTS_LIMITED_READ_ROLE = 17;
const REPORTS_LIMITED_READ_ROLE = 18;
const FUEL_TANK_CARD_UPDATE_ROLE = 19;
const DRIVERS_READ_ROLE = 21;
const DRIVERS_UPDATE_ROLE = 22;
const DRIVERS_CREATE_ROLE = 23;
const DRIVERS_DELETE_ROLE = 24;
const LIMITS_READ_ROLE = 25;
const LIMITS_UPDATE_ROLE = 26;
const LIMITS_CREATE_ROLE = 27;
const LIMITS_DELETE_ROLE = 28;
const COUPONS_READ_ROLE = 29;
const COUPONS_UPDATE_ROLE = 30;
const COUPONS_CREATE_ROLE = 31;
const COUPONS_DELETE_ROLE = 32;
const COMPANIES_READ_ROLE = 33;
const COMPANIES_CREATE_ROLE = 34;
const COMPANIES_UPDATE_ROLE = 35;
const COMPANIES_DELETE_ROLE = 36;
const CLIENTS_READ_ROLE = 37;
const CLIENTS_CREATE_ROLE = 38;
const CLIENTS_UPDATE_ROLE = 39;
const CLIENTS_DELETE_ROLE = 40;
const SCFG_USERS_READ_ROLE = 41;
const SCFG_USERS_CREATE_ROLE = 42;
const SCFG_USERS_UPDATE_ROLE = 43;
const SCFG_USERS_DELETE_ROLE = 44;
const FUEL_FLOW_METERS_INFO_READ_ROLE = 45;
const AZK_GET_DATA = 50;
const CHECK_EMAIL_CODE = 52;

export const roleService = {
	ADMIN_ROLE,
	TAX_REPORTS_READ_ROLE,
	REPORTS_READ_ROLE,
	CHARTS_READ_ROLE,
	FUEL_TANKS_READ_ROLE,
	FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE,
	FUEL_TANKS_INFO_READ_ROLE,
	REPORTS_ACCOUNTING_SYSTEM_READ_ROLE,
	CHARTS_ACCOUNTING_SYSTEM_READ_ROLE,
	SUPER_ADMIN_ROLE,
	FUEL_TANKS_MAP_READ_ROLE,
	REPORTS_EXPORT_ROLE,
	FUEL_TANKS_INFO_EXPORT_ROLE,
	REPORTS_GROUP_DAYS_ROLE,
	CHARTS_LIMITED_READ_ROLE,
	REPORTS_LIMITED_READ_ROLE,
	FUEL_TANK_CARD_UPDATE_ROLE,
	DRIVERS_READ_ROLE,
	DRIVERS_UPDATE_ROLE,
	DRIVERS_CREATE_ROLE,
	DRIVERS_DELETE_ROLE,
	COUPONS_READ_ROLE,
	COUPONS_UPDATE_ROLE,
	COUPONS_CREATE_ROLE,
	COUPONS_DELETE_ROLE,
	LIMITS_READ_ROLE,
	LIMITS_UPDATE_ROLE,
	LIMITS_CREATE_ROLE,
	LIMITS_DELETE_ROLE,
	COMPANIES_READ_ROLE,
	COMPANIES_UPDATE_ROLE,
	COMPANIES_CREATE_ROLE,
	COMPANIES_DELETE_ROLE,
	CLIENTS_READ_ROLE,
	CLIENTS_UPDATE_ROLE,
	CLIENTS_CREATE_ROLE,
	CLIENTS_DELETE_ROLE,
	SCFG_USERS_READ_ROLE,
	SCFG_USERS_UPDATE_ROLE,
	SCFG_USERS_CREATE_ROLE,
	SCFG_USERS_DELETE_ROLE,
	FUEL_FLOW_METERS_INFO_READ_ROLE,
	AZK_GET_DATA,
	CHECK_EMAIL_CODE,
	getRoles,
	getAllowedRoles
};

async function getRoles() {
	const result = await apiService.get('role/getRoles');
	return result;
}

async function getAllowedRoles() {
	const result = await apiService.get('role/getAllowedRoles');
	return result;
}
